// extracted by mini-css-extract-plugin
export default {"verifiedButton":"EmailVerificationHint_verifiedButton__v-Ig8","verifiedText":"EmailVerificationHint_verifiedText__KgIc2"};